<div class="card p-4">
    @if (loading) {
    <div class="d-flex justify-content-center align-items-center py-5">
        <ion-spinner></ion-spinner>
    </div>
    } @else if (data) { @if (validationStatus === 'rejected') {
    <div class="alert alert-warning mb-4" role="alert">
        <h2 class="h6 mb-2">{{ 'offer_rejection_title' | translate }}</h2>
        <p class="mb-3 small">{{ validationRejectionReason }}</p>
    </div>
    }

    <app-create-offer
        #createOfferPage
        [isEdit]="true"
        [initialData]="data"
        [offerToEdit]="offer"
        [editValidationStatus]="validationStatus"
        [resubmitting]="resubmitting"
        (resubmit)="onBoostSubmit()"
    ></app-create-offer>
    }
</div>
